import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
  GridToolbarColumnsButton,
  GridToolbarExportContainer,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeadertab.js";
import CloseIcon from "@mui/icons-material/Close";
import Themgiayvantai from "components/Giayvantai/Themgiayvantai.js";
import Capnhatgiayvantai from "components/Giayvantai/Capnhatgiayvantai.js";
import Mauhopdongvantai from "components/Hopdongvantai/Mauphuluc/Mauhopdongvantai.js";
import Baocaogiayvantaiexcel from "components/Xuatexcel/Baocaogiayvantaiexcel.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import dayjs from "dayjs";
import styles from "assets/jss/material-dashboard-react/components/tableviewStyle.js";
const useStyles = makeStyles(styles);
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const gvtcolumn = [
  {
    field: "ngaygiayvantai",
    headerName: "Ngày giấy vận tải",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "bienkiemsoat",
    headerName: "Biển kiểm soát",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "sogiayvantai",
    headerName: "Số GVT",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngayhethan",
    headerName: "Ngày hết hạn",
    width: 160,
    headerAlign: "center",
  },
  {
    field: "sohopdong",
    headerName: "Số hợp đồng",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngayhopdong",
    headerName: "Ngày hợp đồng",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "tennguoithue",
    headerName: "Người thuê",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "diachinguoithue",
    headerName: "Địa chỉ đơn vị thuê",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "tuyenvanchuyen",
    headerName: "Tuyến vận chuyển",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "diemxephang",
    headerName: "Điểm xếp hàng",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "tg_xephang",
    headerName: "Thời gian xếp hàng",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "diemgiaohang",
    headerName: "Điểm giao hàng",
    width: 250,
    headerAlign: "center",
  },
  {
    field: "tg_giaohang",
    headerName: "Thời gian giao hàng",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "quangduong",
    headerName: "Quãng đường (km)",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "tenhanghoa",
    headerName: "Hàng hóa",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "khoiluonghanghoa",
    headerName: "Khối lượng (kg)",
    width: 140,
    headerAlign: "center",
  },
  {
    field: "hanghoathongtinkhac",
    headerName: "Thông tin khác",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "ngaycn",
    headerName: "Ngày cập nhật",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "nguoicn",
    headerName: "Người cập nhật",
    width: 150,
    headerAlign: "center",
  },
];
export default function Giayvantai() {
  const classes = useStyles();
  const [pageSize, setPageSize] = React.useState(50);
  const [openthem, setOpenthem] = React.useState(false);
  const [openphuluc, setOpenphuluc] = React.useState(false);
  const [thangnam, setThangnam] = React.useState(dayjs());
  const [giayvantai, setGiayvantai] = React.useState([]);
  const [giayvantai_id, setGiayvantai_id] = React.useState(0);
  const [disableBT, setDisableBT] = React.useState(true);
  const [opensua, setOpensua] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
        <GridToolbarColumnsButton />
        <GridToolbarExportContainer>
          <Baocaogiayvantaiexcel />
        </GridToolbarExportContainer>
      </Box>
    );
  };
  const handleClose = () => {
    setOpenthem(false);
    getgiayvantai(thangnam);
  };
  const handleClosesua = () => {
    setOpensua(false);
    getgiayvantai(thangnam);
  };
  const handleClosephuluc = () => {
    setOpenphuluc(false);
    getgiayvantai(thangnam);
  };
  const openthembc = () => {
    setOpenthem(true);
    setDisableBT(true); // fix delete button
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getgiayvantai = (thangnambc) => {
    setDisableBT(true); // fix delete button
    var thang =
      String(thangnambc.$M + 1).padStart(2, "0") + "/" + thangnambc.$y;
    var url =
      Config.backend +
      "/api/CoSoGTVT/getgiayvantaiuserthang?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setGiayvantai(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const xoagiayvantai = () => {
    var url = Config.backend + "/api/CoSoGTVT/xoagiayvantai";
    fetch(url, {
      method: "DELETE",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: giayvantai_id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
          getgiayvantai(thangnam);
          setDisableBT(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  React.useEffect(() => {
    getgiayvantai(thangnam);
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ marginTop: 5 }}>
        <FormControl style={{ width: "15%" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Chọn tháng năm"
              value={thangnam}
              onChange={(newValue) => {
                setThangnam(newValue);
                getgiayvantai(newValue);
              }}
              format="MM/YYYY"
              slotProps={{ textField: { size: "small" } }}
              views={["month", "year"]}
              sx={{
                "& .MuiInputBase-root": {
                  height: "27px",
                },
              }}
            />
          </LocalizationProvider>
        </FormControl>
        <FormControl style={{ width: "12%", marginLeft: 10 }}>
          <Button
            color="success"
            variant="contained"
            style={{ height: 27 }}
            onClick={openthembc}
          >
            Thêm mới
          </Button>
        </FormControl>
        <FormControl style={{ width: "8%", marginLeft: 10 }}>
          <Button
            color="error"
            variant="contained"
            style={{ height: 27 }}
            disabled={disableBT}
            onClick={xoagiayvantai}
          >
            Xóa
          </Button>
        </FormControl>
        <FormControl style={{ width: "12%", marginLeft: 10 }}>
          <Button
            color="warning"
            variant="contained"
            style={{ height: 27 }}
            disabled={disableBT}
            onClick={() => setOpenphuluc(true)}
          >
            Phụ lục
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%", marginTop: 10 }}>
          <DataGrid
            getRowId={(row) => row.id}
            rows={giayvantai}
            columns={gvtcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            onRowClick={(params) => {
              setDisableBT(false);
              setGiayvantai_id(params.row.id);
            }}
            onCellDoubleClick={(params, event) => {
              if (!event.ctrlKey) {
                setOpensua(true);
                setDisableBT(true); // fix delete button
              }
            }}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
          />
        </div>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openthem}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={8}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Thêm giấy vận tải
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClose} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Themgiayvantai />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={opensua}
          onClose={handleClosesua}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={8}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={10}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Cập nhật giấy vận tải
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={1}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosesua} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Capnhatgiayvantai giayvantai_id={giayvantai_id} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={2}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <Modal
          open={openphuluc}
          onClose={handleClosephuluc}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div>
            <GridContainer>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader color="primary" style={{ height: 10 }}>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={8}>
                        <FormControl
                          style={{ width: "100%", marginTop: "10px" }}
                        >
                          <h6
                            className={classes.cardTitleWhite}
                            style={{ marginTop: "-5px" }}
                          >
                            Mẫu phụ lục
                          </h6>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}></GridItem>
                      <GridItem xs={12} sm={12} md={1}>
                        <FormControl
                          style={{ width: "100%", marginTop: "1px" }}
                        >
                          <CloseIcon onClick={handleClosephuluc} />
                        </FormControl>
                      </GridItem>
                    </GridContainer>
                  </CardHeader>
                  <Mauhopdongvantai giayvantai_id={giayvantai_id} />
                </Card>
              </GridItemLogin>
              <GridItemLogin xs={12} sm={12} md={3}></GridItemLogin>
            </GridContainer>
          </div>
        </Modal>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Xóa thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
